import { parsePhoneNumber } from 'libphonenumber-js';

export const toNational = (phone, defaultValue) => {
    if (phone && phone.length) {
        try {
            const parsedPhoneNumber = parsePhoneNumber(phone, 'US');
            if (parsedPhoneNumber.isValid()) {
                return parsedPhoneNumber.formatNational();
            }
        } catch (e) {
            // console.error(e);
        }

        return defaultValue || `${phone} (Invalid Phone #)`;
    }
    return defaultValue || 'Missing Phone #';
};

// Formats to E.164 when the number parses. When it does not — unparseable or absent —
// hand back exactly what came in, or the caller's explicit fallback. This feeds phone
// columns, so it must never invent a display placeholder; toNational() owns those.
export const toE164 = (phone, defaultValue) => {
    if (phone && phone.length) {
        try {
            const parsedPhoneNumber = parsePhoneNumber(phone, 'US');
            if (parsedPhoneNumber.isValid()) {
                return parsedPhoneNumber.format('E.164');
            }
        } catch (e) {
            // console.error(e);
        }
    }

    return defaultValue === undefined ? phone : defaultValue;
};

export const validate = (phone) => {
    if (phone && phone.length) {
        try {
            const parsedPhoneNumber = parsePhoneNumber(phone, 'US');
            if (parsedPhoneNumber.isValid()) {
                return true;
            }
        } catch (e) {
            // console.error(e);
        }
    }
    return false;
};

// null the formatters' display placeholders so they never persist; keep genuine input for UI validation
export const stripPlaceholderPhone = (value) => {
    if (typeof value !== 'string') {
        return value;
    }
    const trimmed = value.trim();
    const isMissing = trimmed === 'Missing Phone #';
    const isInvalidText = / \(Invalid Phone #\)$/.test(trimmed);
    return isMissing || isInvalidText ? null : value;
};
